import { Link } from "react-router-dom";
import { motion } from "framer-motion";

export default function Footer({ onStartProject }) {
  return (
    <footer className="bg-ink text-ivory relative overflow-hidden" data-testid="site-footer">
      <div className="mx-auto max-w-[1600px] px-6 md:px-12 pt-24 md:pt-40 pb-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-16 lg:gap-24">
          <div className="lg:col-span-8">
            <p className="font-mono text-[11px] uppercase tracking-[0.28em] text-ivory/60">
              [ 07 ] &nbsp;·&nbsp; Colophon
            </p>
            <motion.h2
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-100px" }}
              transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
              className="mt-8 font-display text-[13vw] md:text-[9vw] leading-[0.88] tracking-tightest"
            >
              Brands worth
              <br />
              <em className="italic font-normal text-ivory/70">building.</em>
            </motion.h2>
            <button
              onClick={onStartProject}
              data-testid="footer-start-project"
              className="mt-14 inline-flex items-center gap-4 border-b border-ivory/40 pb-2 text-[13px] uppercase tracking-[0.24em] hover:text-ivory hover:border-ivory transition-colors"
            >
              Start a project
              <span className="text-lg">→</span>
            </button>
          </div>

          <div className="lg:col-span-4 grid grid-cols-2 gap-10 text-sm">
            <div>
              <p className="font-mono text-[10px] uppercase tracking-[0.24em] text-ivory/50 mb-4">Studio</p>
              <p className="leading-relaxed text-ivory/80">
                Sevoke Road<br />Siliguri, WB 734001<br />India
              </p>
            </div>
            <div>
              <p className="font-mono text-[10px] uppercase tracking-[0.24em] text-ivory/50 mb-4">Contact</p>
              <a href="mailto:hello@bosecrafts.com" className="u-link block mb-1">hello@bosecrafts.com</a>
              <p className="text-ivory/60">+91 · on request</p>
            </div>
            <div>
              <p className="font-mono text-[10px] uppercase tracking-[0.24em] text-ivory/50 mb-4">Index</p>
              <ul className="space-y-1">
                <li><Link to="/" className="u-link">Home</Link></li>
                <li><Link to="/work" className="u-link">Work</Link></li>
                <li><Link to="/studio" className="u-link">Studio</Link></li>
                <li><Link to="/contact" className="u-link">Contact</Link></li>
              </ul>
            </div>
            <div>
              <p className="font-mono text-[10px] uppercase tracking-[0.24em] text-ivory/50 mb-4">Elsewhere</p>
              <ul className="space-y-1">
                <li><a href="#" className="u-link">Instagram</a></li>
                <li><a href="#" className="u-link">Are.na</a></li>
                <li><a href="#" className="u-link">LinkedIn</a></li>
              </ul>
            </div>
          </div>
        </div>

        <div className="mt-24 flex flex-col md:flex-row justify-between gap-4 pt-6 border-t border-ivory/15 text-[11px] uppercase tracking-[0.22em] text-ivory/50 font-mono">
          <span>© {new Date().getFullYear()} Bosecrafts. All quiet rights reserved.</span>
          <span className="flex items-center gap-2">
            <span className="status-dot" />
            Currently available — Q3 2026
          </span>
        </div>
      </div>
    </footer>
  );
}
